import { Modal, Form, Input, Button } from "antd";
import { useEffect } from "react";

const AddModal = ({ isModalVisible, handleOk, handleCancel, loading }) => {
  const [form] = Form.useForm();


  const onFinish = (values) => {
    handleOk({ ...values});
  };

  useEffect(() => {
    form.resetFields();
  }, [form, isModalVisible]);

  return (
    <Modal
      title="Add New Master Tag"
      open={isModalVisible}
      footer={null} // Remove default buttons
      onCancel={() => {
        handleCancel();
        form.resetFields();
      }}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="name"
          label="Master Tag Name"
          rules={[{ required: true, message: "Please enter Master Tag Name", whitespace: true}]}
        >
          <Input placeholder="Enter Master Tag Name" maxLength={50} showCount />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: false, message: "Please enter Description", whitespace: true }]}
        >
          <Input.TextArea rows={3} placeholder="Enter Description" maxLength={50} showCount />
        </Form.Item>

        <Form.Item>
          <div className="flex items-center justify-end gap-4">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddModal;
